module.exports = __webpack_public_path__ + "img/hqmfrags.dee0ae75.png";